import { DURATION } from '../config.js';
import { checkSliderZone } from '../zones-map.js';
import { setProgrammaticSlide } from './scroll-swiper.js';

let isAnchorNav = false;

export function setAnchorNav(state) {
  isAnchorNav = state;
}

export function handleStaticSlide(instance, active, direction) {
  if (isAnchorNav) return;

  const isStatic = active.classList.contains('slide-static');
  if (!isStatic) return;

  // --- Перевіряємо чи є атрибут data-scrollnumber ---
  const maxStops = parseInt(active.dataset.scrollnumber, 10);

  if (!isNaN(maxStops) && maxStops > 1) {
    if (!active.dataset.scrollCount) {
      active.dataset.scrollCount = 0;
    }

    let count = parseInt(active.dataset.scrollCount, 10);

    if (direction === 'prev') {
      if (count > 0) {
        active.dataset.scrollCount = count - 1;
        checkSliderZone(count, active);
        active.classList.remove(`is-static${count}`);

        setTimeout(() => {
          setProgrammaticSlide(true);
          instance.slideTo(instance.activeIndex + 1, 0);
          instance.mousewheel.disable();
        }, 0);

        setTimeout(() => {
          instance.mousewheel.enable();
        }, DURATION);

        return;
      }
    }

    if (direction === 'next') {
      if (count < maxStops) {
        active.dataset.scrollCount = count + 1;
        checkSliderZone(count + 2, active);
        active.classList.add(`is-static${count + 1}`);

        setTimeout(() => {
          setProgrammaticSlide(true);
          instance.mousewheel.disable();
          instance.slideTo(instance.previousIndex, 0);
        }, 0);

        setTimeout(() => {
          instance.mousewheel.enable();
        }, DURATION);

        return;
      }
    }
  } else {
    const hasStatic = active.classList.contains('is-static');

    if (direction === 'prev') {
      if (isStatic && hasStatic) {
        active.classList.remove('is-static');

        setTimeout(() => {
          instance.slideTo(instance.activeIndex + 1, 0);
          instance.mousewheel.disable();
        }, 0);

        setTimeout(() => {
          instance.mousewheel.enable();
        }, DURATION);
      }
    } else if (direction === 'next') {
      if (isStatic && !hasStatic) {
        active.classList.add('is-static');

        setTimeout(() => {
          setProgrammaticSlide(true);
          instance.slideTo(instance.previousIndex, 0);
          instance.mousewheel.disable();
        }, 0);

        setTimeout(() => {
          instance.mousewheel.enable();
        }, DURATION);
      }
    } else if (direction === 'first') {
      if (isStatic && hasStatic) {
        active.classList.remove('is-static');

        setTimeout(() => {
          setProgrammaticSlide(true);
          instance.slideTo(instance.activeIndex, 0);
          instance.mousewheel.disable();
        }, 0);
        setTimeout(() => {
          instance.mousewheel.enable();
        }, DURATION);
      }
    }
  }
}

export function syncStaticSlides(instance) {
  const slides = Array.from(instance.slides);

  slides.forEach((slide, index) => {
    if (!slide.classList.contains('slide-static')) return;

    const maxStops = parseInt(slide.dataset.scrollnumber, 10);

    if (!isNaN(maxStops) && maxStops > 1) {
      if (index <= instance.activeIndex) {
        slide.dataset.scrollCount = maxStops;
        checkSliderZone(maxStops + 1, slide);
        slide.classList.add(`is-static${maxStops}`);

        for (let i = 1; i <= maxStops; i++) {
          slide.classList.add(`is-static${i}`);
        }
      } else {
        slide.dataset.scrollCount = 0;
        checkSliderZone(1, slide);
        for (let i = 1; i <= maxStops; i++) {
          slide.classList.remove(`is-static${i}`);
        }
      }
    } else {
      if (index <= instance.activeIndex) {
        slide.classList.add('is-static');
      } else {
        slide.classList.remove('is-static');
      }
    }
  });
}

export function resetStaticSlides() {
  if (window.innerWidth > 960) return;

  const staticSlides = document.querySelectorAll('.slide-static');
  staticSlides.forEach(slide => {
    if (slide.dataset.scrollnumber) {
      const maxStops = parseInt(slide.dataset.scrollnumber, 10);

      slide.dataset.scrollCount = 0;

      for (let i = 1; i <= maxStops; i++) {
        slide.classList.remove(`is-static${i}`);
      }
    }

    slide.classList.remove('is-static');
  });
}

window.addEventListener('resize', resetStaticSlides);
document.addEventListener('DOMContentLoaded', resetStaticSlides);
